export const REACT_APP_BASE_URL1 = "/api/v1"
export const BASE_URL_IMAGE = "https://storagemilfordprod.blob.core.windows.net/stories";
// Chetu QA Env Below:
// export const  REACT_APP_BASE_URL2 = "https://milfordrealestate-real-api.chetu.com/api"

// Client QA Env Below:
// export const REACT_APP_BASE_URL2 = "https://milfordrealestateqa.azurewebsites.net/api"
// export const REACT_APP_BASE_URL2 = "https://uatrealestate.milford.com/api"

export const REACT_APP_BASE_URL2 = "https://milfordrealestate-uat.azurewebsites.net/api"
// export const REACT_APP_BASE_URL2 = "https://milfordrealestate-prod-csharp.azurewebsites.net/api"

// export const REACT_APP_BASE_URL2 = "https://milfordrealestate-uat.azurewebsites.net/api"
// export const REACT_APP_BASE_URL2 = "http://localhost:24601/api"
// export const REACT_APP_BASE_URL3 = "https://localhost:7109/api"
// export const REACT_APP_BASE_URL2 = "https://milfordrealestate-prod.azurewebsites.net/api"
// https://milfordrealestateqa.azurewebsites.net/swagger/index.html
